import { IstanzaAttivitaDTO } from "./istanza-attivitaDTO";

export class AttivitaEreditataDTO {
  attivitaAssociata: IstanzaAttivitaDTO;
  idFascicolo: string;
}
